import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'


class AdminUsers extends Component {

  standardRow = (user) => {
    this.props.info('AdminUsers.js/standardRow (user)', user);
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(user.auth0)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(user['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((user['active']) ? 'iconActive' : 'iconInactive')} />
          {user['lastName'] + ', ' + user['firstName']}
        </Col>
        <Col md={8} className="text-left">{user['emailAddress']}</Col>
        {/* <Col md={4} className="text-right">
          <Button color="primary" onClick={() => this.props.onEdit(user.Auth0)}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </Col> */}
      </Row>
    )
  }

  editRow = (user) => {
    this.props.log('AdminUsers.js/editRow (user)', user);
    return (<>
      <Row key={"edit" + user.auth0} className="adminRow activeTab">
        <Col md={9} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="First Name"
                type="text"
                id={"edit-firstName" + user.auth0}
                name="firstName"
                value={this.props.isFieldNull(this.props.editUser.firstName)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Last Name"
                type="text"
                id={"edit-lastName" + user.auth0}
                name="lastName"
                value={this.props.isFieldNull(this.props.editUser.lastName)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Email Address"
                type="text"
                id={"edit-emailAddress" + user.auth0}
                name="emailAddress"
                value={this.props.isFieldNull(this.props.editUser.emailAddress)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="select"
                name="employeeId"
                value={this.props.isFieldNull(this.props.editUser.employeeId)}
                onChange={e => this.props.onChange(e, 'edit')} >
                <option value={0}>ASSOCIATED EMPLOYEE</option>
                {this.props.employees.map(employee => (
                  <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"user-active" + user.auth0}
                name="active"
                checked={this.props.isFieldNull(this.props.editUser.active, true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"user-active" + user.auth0}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit User">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          {/* <Button className="mx-1" color="primary" onClick={() => this.props.handlePasswordReset(user.auth0)}>
            <FontAwesomeIcon icon={faLock} />
          </Button> */}
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={3} className="text-right p-3">
          Assigned Roles
          <div className="mt-3">
            <Label for={"userRole_all"}>
              <Input
                type="checkbox"
                name="roles"
                id={"userRole_all"}
                checked={this.props.editUser.roles.length === this.props.roles.length}
                onChange={e => this.props.onSelectAll(e, {
                  type: 'roles',
                  typeKey: 'id',
                  target: 'editUser'
                })}
              />
              Select All
            </Label>
          </div>
        </Col>
        <Col md={3} className="text-left py-3 pl-5 maxHpanel">
          {this.props.roles.map(role => (
            <div key={role.id}><Label key={role.id} for={"userRole_" + role.id}>
              <Input
                type="checkbox"
                name="roles"
                id={"userRole_" + role.id}
                checked={this.props.isFieldNull(this.props.editUser.roles.findIndex(i => i === parseInt(role.id)) > -1, true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {role.role}
            </Label></div>
          ))}
        </Col>
        <Col md={3} className="text-right p-3">
          Assigned Clients
          <div className="mt-3">
            <Label for={"userClient_all"}>
              <Input
                type="checkbox"
                name="roles"
                id={"userClient_all"}
                checked={this.props.editUser.clients.length === this.props.clients.length}
                onChange={e => this.props.onSelectAll(e, {
                  type: 'clients',
                  typeKey: 'id',
                  typePath: 'props',
                  target: 'editUser'
                })}
              />
              Select All
            </Label>
          </div>
        </Col>
        <Col md={3} className="text-left pl-5 py-3 maxHpanel">
          {this.props.clients.filter(client => client.active).map(client => (
            <div key={client.id}><Label key={client.id} for={"userClient_" + client.id}>
              <Input
                type="checkbox"
                name="clients"
                id={"userClient_" + client.id}
                checked={this.props.isFieldNull(this.props.editUser.clients.findIndex(i => i === parseInt(client.id)) > -1, true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {client.client}
            </Label></div>
          ))}
        </Col>
      </Row>
    </>
    )
  }

  addRow = () => {
    this.props.info('AdminRoles.js/addRow');
    return (<Row className="py-4 text-left align-items-bottom">
      <Col>
        <Form inline>
          {/* <FormGroup className="pr-2">
            Add New Role
          </FormGroup> */}
          <FormGroup className="px-2">
            <Input
              placeholder="First Name"
              type="text"
              name="firstName"
              value={this.props.isFieldNull(this.props.newUser.firstName)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Last Name"
              type="text"
              name="lastName"
              value={this.props.isFieldNull(this.props.newUser.lastName)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Email Address"
              type="text"
              name="emailAddress"
              value={this.props.isFieldNull(this.props.newUser.emailAddress)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              type="select"
              name="employeeId"
              value={this.props.isFieldNull(this.props.newUser.employeeId)}
              onChange={e => this.props.onChange(e)} >
              <option value={0}>ASSOCIATED EMPLOYEE</option>
              {this.props.employees.map(employee => (
                <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              type="checkbox"
              name="active"
              id="user-active"
              checked={this.props.isFieldNull(this.props.newUser.active, true)}
              onChange={e => this.props.onChange(e)} />
            <Label for="user-active">
              Active
            </Label>
          </FormGroup>
        </Form>
      </Col>
      <Col md={3} className="text-right">
        <Button disabled={this.props.newUser.emailAddress === ''} color="primary" onClick={this.props.handleAdd}>Add User</Button>
      </Col>
    </Row>
    )
  }

  render() {
    this.props.info('AdminUsers.js/render');
    return (
      <Container className="adminContainer" fluid>
        {this.props.users.map(user => (
          <Fragment key={user.auth0}>{this.props.editUser.auth0 === user.auth0 ? this.editRow(user) : this.standardRow(user)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default AdminUsers;
